<template>
  <div class="bMails">
    <div class="bMails__container container pt-4">
      <div class="bMails__header row">
        <div class="bMails__header__h2 h2 col">信件匣</div>
      </div>
      <div class="bMails__body d-flex flex-column align-items-center">
        <form class="bMails__form w-100 pb-3 position-relative"
        v-for="(item, index) in mails"
        :key="index"
        @submit.prevent="submit_reply(index)">
          <b-button
          v-b-toggle="item.id"
          class="my-1 w-100 d-flex flex-wrap align-items-center">
            <span class="col-12 col-md-4 pb-2 pb-md-0">
              {{item.name}}
            </span>
            <span class="col-12 col-md-4  pb-2 pb-md-0">
              {{convert_time(item.time)}}
            </span>
            <span class="col-12 col-md-4 ">
              <button v-if="!item.read" class="btn btn-success"
              type="button"
              @click="toggle_read(item.id, true)">
                標為已讀
              </button>
              <button v-if="item.read" class="btn btn-warning"
              type="button"
              @click="toggle_read(item.id, false)">
                標為未讀
              </button>
            </span>
          </b-button>
          <b-collapse :id="item.id">
            <b-card>
              <div class="card-body p-0 d-flex flex-column flex-md-row">
                <h6 class="card-title
                text-md-right pr-md-3">
                寄件人</h6>
                <div class="card-text mb-3 mb-md-0">
                  {{item.name}}
                </div>
              </div>
              <div class="card-body p-0 d-flex flex-column flex-md-row">
                <h6 class="card-title
                text-md-right pr-md-3">
                寄件日期</h6>
                <div class="card-text mb-3 mb-md-0">
                  {{convert_time(item.time)}}
                </div>
              </div>
              <div class="card-body p-0 d-flex flex-column flex-md-row">
                <h6 class="card-title
                text-md-right pr-md-3">
                連絡電話</h6>
                <div class="card-text mb-3 mb-md-0">
                  <a :href="`tel: ${item.tel}`" class="text-primary">{{item.tel}}</a>
                </div>
              </div>
              <div class="card-body p-0 d-flex flex-column flex-md-row">
                <h6 class="card-title
                text-md-right pr-md-3">
                連絡email</h6>
                <div class="card-text mb-3 mb-md-0">
                  <a :href="`mailto: ${item.mail}`" class="text-primary">{{item.mail}}</a>
                </div>
              </div>
              <div class="card-body p-0 d-flex flex-column flex-md-row">
                <h6 class="card-title
                text-md-right pr-md-3">
                信件內容</h6>
                <div class="card-text mb-3 mb-md-0" v-html="item.content"></div>
              </div>
              <hr>
              <div class="card-body p-0 d-flex flex-column flex-md-row"
              v-if="item.reply.id !== ''">
                <h6 class="card-title
                text-md-right pr-md-3">
                回覆人</h6>
                <div class="card-text mb-3 mb-md-0">{{item.reply.name}}</div>
              </div>
              <div class="card-body p-0 d-flex flex-column flex-md-row"
              v-if="item.reply.id !== ''">
                <h6 class="card-title
                text-md-right pr-md-3">
                回覆時間</h6>
                <div class="card-text mb-3 mb-md-0">{{convert_time(item.reply.time)}}</div>
              </div>
              <div class="card-body p-0 d-flex flex-column flex-md-row"
              v-if="item.reply.id !== ''">
                <h6 class="card-title
                text-md-right pr-md-3">
                回覆內容</h6>
                <div class="card-text mb-3 mb-md-0" v-html="item.reply.content"></div>
              </div>
              <div class="form-group"
              v-if="item.reply.id === ''">
                <label>回覆內容</label>
                <textarea class="form-control"
                rows="5"
                placeholder="回覆內容"
                required
                v-model="item.reply.content"></textarea>
              </div>
              <div class="d-flex justify-content-end"
              v-if="item.reply.id === ''">
                <button class="btn btn-info mr-3"
                type="submit">
                  送出回覆
                </button>
              </div>
            </b-card>
          </b-collapse>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['admin'],
  data() {
    return {
      mails: [],
    };
  },
  methods: {
    initialize_mails() {
      let mArr;
      this.$bus.$on('son_get_data', (data) => {
        mArr = data.mails;
      });
      this.$bus.$emit('son_call_data');
      const sortMails = (arr) => {
        arr.sort((a, b) => {
          const timeA = JSON.parse(a.time);
          const timeB = JSON.parse(b.time);
          // 由大到小排序
          return timeB - timeA;
        });
      };
      sortMails(mArr);
      this.mails = mArr;
    },
    convert_time(time) {
      const formatDate = new Date(JSON.parse(time));
      const covertTimeText = (d) => {
        const year = d.getFullYear();
        const month = d.getMonth() + 1;
        const day = d.getDate();
        return `${year} 年 ${month} 月 ${day} 日`;
      };
      return covertTimeText(formatDate);
    },
    toggle_read(id, boolean) {
      this.$bus.$emit('toggle_mail_read', id, boolean);
      this.initialize_mails();
    },
    submit_reply(mailIndex) {
      const tMail = this.mails[mailIndex];
      const timeNow = (new Date()).getTime();
      const replyTime = JSON.stringify(timeNow);
      const replyId = `mailReply${replyTime}`;
      const replyName = this.admin.name;
      tMail.reply.id = replyId;
      tMail.reply.time = replyTime;
      tMail.reply.name = replyName;
      this.$bus.$emit('submit_mailReply', tMail.id, tMail.reply);
      this.initialize_mails();
    },
  },
  created() {
    this.initialize_mails();
  },
};
</script>
